import React from "react";
import {Link} from "react-router-dom";
import "./menuCategory.css";
import {Utils} from "../../utils/utils.js";

export class MenuCategory extends React.Component {

	constructor(props) {
		super(props);

		this.category = props.category;
		this.routes = props.routes;

		this.state = {
			isContainerVisible: true
		};

		let self = this;

		this.categoryElement = null !== this.category ? 
			<h3 className="fgcomp menuCategory categoryItem"
				onClick={self.toggleShowContainer}>
				{this.category}
			</h3> :
			<div></div>

		let labelStyle = {};

		if (null != this.category) {
			labelStyle = {paddingLeft: ".5em",};
		}

		this.container =
			<div className="routeContainer"> {
					this.props.routes.map( route => {
							let className="routeLink"

							if ( route.class_list ) {
								className=className + " " + route.class_list
							}

							return (
								<div key={route.path} 
									className={className}>
									<Link to={route.path} className={className}
										onClick={Utils.hideAllDropDowns}>
										<h3 style={labelStyle} className="defaultRouteLinkLabel">
											&bull; {route.label}
										</h3>
									</Link>
								</div>
							)
						}
					)
				}
			</div>

	}

	toggleShowContainer = (event) => {
		//console.log("toggleShowContainer()")
		event.preventDefault();
		event.stopPropagation();

		/*`
		this.setState(
			{ isContainerVisible: !this.state.isContainerVisible }
		);
		*/

	}

	render() {

		return (
			<React.Fragment>
				{this.categoryElement}
				{ this.state.isContainerVisible && this.container }
			</React.Fragment>
		);

	}

}
